require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = setDefaultThemeStyle;

var _nativeBaseShoutemTheme = require('native-base-shoutem-theme');

var _components = require("./theme/components");

var _components2 = _interopRequireDefault(_components);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function setDefaultThemeStyle() {
  var theme = (0, _components2["default"])();

  _nativeBaseShoutemTheme.Theme.setDefaultThemeStyle(theme);
}